import { useEffect } from "react";
import styled from "styled-components";

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  .title {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    & h6 {
      @media screen and (max-width: 991px) {
        font-size: 14px !important;
      }
      @media screen and (max-width: 575px) {
        font-size: 12px !important;
        white-space: nowrap;
      }
    }
  }
`;

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ececec;
  justify-content: center;
  align-items: center;
  > div {
    width: 100%;
  }
  & label {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 7px;
    margin: 0px;
    cursor: pointer;
    @media screen and (max-width: 460px) {
      font-size: 12px !important;
      padding: 5px;
    }
  }

  & input {
    display: none;
  }
`;

const Radio = styled.input``;
const Label = styled.label`
  background-color: ${(props) => (props.checked ? "#3bb77e" : "#fff")};
  color: ${(props) => (props.checked ? "#fff" : "#7e7e7e")};
  border-bottom: ${(props) => (props.i == 0 ? "1px solid #ececec" : "none")};
`;

const ErrorMsg = styled.span`
  color: #dc3545;
`;

const CustomRadio = ({
  title,
  code,
  options,
  openModal,
  register,
  formState,
  reset,
  getValues,
  watch,
  detailData,
}) => {
  return (
    <>
      <Div>
        <div className="title">
          <h6>{title.split("_")[1]}</h6>
        </div>
        <RadioWrapper>
          {options?.map((option, i) => (
            <div key={i}>
              <Label
                htmlFor={option.okey}
                i={i}
                checked={watch(code) === option.okey ? true : false}
              >
                {option.oname}
              </Label>
              <Radio
                type={"radio"}
                name={title}
                id={option.okey}
                value={option.okey}
                {...register(code)}
              />
            </div>
          ))}
        </RadioWrapper>
        <ErrorMsg>{formState?.errors[code]?.message}</ErrorMsg>
      </Div>
    </>
  );
};
export default CustomRadio;
